// src/pages/factors/CustomerSearchBox.jsx
import React, { useState, useEffect, useRef } from 'react';
import api from '../../core/api';

export default function CustomerSearchBox({ onSelect }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapperRef = useRef(null);
  const debounceRef = useRef(null);

  /* ============== جستجو با debounce ============== */
  useEffect(() => {
    clearTimeout(debounceRef.current);

    if (query.trim().length < 2) {
      setResults([]);
      setOpen(false);
      return;
    }

    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.get('/customers/search', {
          params: { q: query.trim() },
        });
        // اگر سرور { success, customers } داد یا آرایه خالص
        const list = Array.isArray(res.data)
          ? res.data
          : res.data?.customers || [];
        setResults(list);
        setOpen(true);
      } catch (err) {
        console.error('خطا در جستجو:', err);
        setResults([]);
        setOpen(true);
      } finally {
        setLoading(false);
      }
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [query]);

  /* ============== بستن در صورت کلیک بیرون ============== */
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handlePick = (customer) => {
    onSelect(customer);
    setQuery(customer.name || '');
    setOpen(false);
  };

  return (
    <div style={{ marginBottom: 15 }}>
      <label>جستجوی مشتری (نام یا شماره تلفن)</label>
      <div style={{ position: 'relative' }} ref={wrapperRef}>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="نام یا شماره تلفن مشتری را وارد کنید..."
          autoComplete="off"
        />

        <div
          className={`customer-search-results ${
            open ? 'active' : ''
          }`}
        >
          {loading ? (
            <div className="customer-search-empty">در حال جستجو...</div>
          ) : results.length === 0 ? (
            <div className="customer-search-empty">
              مشتری‌ای یافت نشد
            </div>
          ) : (
            results.map((c) => (
              <div
                key={c.id}
                className="customer-result"
                onClick={() => handlePick(c)}
              >
                <div className="customer-result-name">{c.name}</div>
                <div className="customer-result-info">
                  {c.phone ? `تلفن: ${c.phone}` : ''}
                  {c.city ? ` - ${c.city}` : ''}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
